var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuessPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Resmi Tahmin Et",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp-face",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7CC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2A8CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145BBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gp-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4FA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A6CD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp-frame",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EAF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp-sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7FCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4F0FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gp-q",
    cx: 0.4,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6F0A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gp-photo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 168,
    width: 168,
    height: 140,
    rx: 6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gp-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "gp-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#062B66",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gp-clip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 226
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 272,
    r: 226,
    fill: "#062B66",
    opacity: 0.4,
    filter: "url(#gp-bsh)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 264,
    r: 226,
    fill: "#0E4794"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 226,
    fill: "url(#gp-face)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#0E4794",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#gp-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gp-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#gp-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#gp-osh)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-6 252 258)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 160,
    width: 200,
    height: 212,
    rx: 14,
    fill: "#9FAEC6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 152,
    width: 200,
    height: 212,
    rx: 14,
    fill: "url(#gp-frame)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gp-photo)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 168,
    width: 168,
    height: 140,
    fill: "url(#gp-sky)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 206,
    r: 18,
    fill: "#FFD23F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,312 L222,232 L258,274 L288,244 L350,312 Z",
    fill: "#2E9A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,232 L240,253 L228,262 L214,246 Z",
    fill: "#FFFFFF",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,312 L200,280 L250,312 Z",
    fill: "#3FBF78"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 168,
    width: 168,
    height: 140,
    rx: 6,
    fill: "none",
    stroke: "#C9D3E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 157,
    width: 176,
    height: 7,
    rx: 3.5,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 340,
    r: 46,
    fill: "url(#gp-q)",
    stroke: "#FFFFFF",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 338,
    cy: 318,
    rx: 20,
    ry: 9,
    fill: "#FFFFFF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 360,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 58,
    fill: "#FFFFFF"
  }, "?")), /*#__PURE__*/React.createElement("path", {
    transform: "translate(140 166) scale(16)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(392 230) scale(10)",
    fill: "#FFFFFF",
    opacity: 0.85,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuessPicture);
export default __webpack_public_path__ + "static/media/guess-picture.50dcff0444590e10870f244438b64fa2.svg";
export { ForwardRef as ReactComponent };